import React from "react";
import { Button } from "@intech/web-ui";
import { useHistory } from "react-router-dom";

import config from "./../../../config.json";
import { LGPDService } from "@services";
import { BaseAuth } from "../Base";
import { FaCheck, FaTimes } from "react-icons/fa";

export const Termos: React.FC = () => {
  const history = useHistory();

  async function aceitar() {
    try {
      await LGPDService.Inserir(1);
      history.push("trocarSenhaPrimeiroAcesso");
    } catch (e) {
      const err: any = e;
      const error = err.response ? err.response.data : err;
      console.log(error);
    }
  }

  function recusar() {
    window.alert(
      "Sem o consentimento expresso no termo, o acesso ao portal do Participante não será permitido. Para mais informações, entre em contato conosco através dos nossos canais de atendimento."
    );
    localStorage.removeItem(`@${config.appName}:token`);
    localStorage.removeItem(`@${config.appName}:token-admin`);
    history.push("login");
  }

  return (
    <BaseAuth tamanho={550}>
      <h5 className="mt-5">
        <b>
          TERMO DE CONSENTIMENTO E AUTORIZAÇÃO LIVRE, ESCLARECIDO E INEQUÍVOCO
          DE UTILIZAÇÃO DE DADOS PESSOAIS
        </b>
      </h5>

      <p style={{ textAlign: "justify" }}>
        Em observância a Lei nº 13.709/2018 ("Lei Geral de Proteção de Dados
        Pessoais"), autorizo a REGIUS a realizar o tratamento dos meus dados
        pessoais, fornecidos desde minha adesão aos Planos sob administração
        desta Entidade Fechada de Previdência Complementar, utilizando tais
        informações tão somente para os fins lícitos e previstos na consecução
        do Plano em que sou participante ou assistido, bem como utilizá-las nas
        avaliações atuariais e financeiras e, ainda, compartilhá-las com os
        órgãos governamentais que legalmente os requererem.
      </p>

      <Button
        title={"Li e concordo com o termo acima"}
        onClick={aceitar}
        type={"primary"}
        block
        icon={<FaCheck />}
        usesLoading
        loadingText={"Carregando..."}
      />
      <Button
        title={"Agora não"}
        onClick={recusar}
        type={"light"}
        block
        icon={<FaTimes />}
      />
    </BaseAuth>
  );
};
